export default {
  props: {
    loading: {
      default: false,
    }
  },
  data(){
    return {
      isLoading: this.loading
    }
  },
  watch: {
    loading(){
      /**
       * Изменяет значение isLoading при изменении loading
       */
      this.isLoading = this.loading
    }
  },
  computed: {
  },
  methods: {
    setLoading(){
      /**
       * Устанавливает значение loading на true
       */
      this.isLoading = true;
      this.$emit('update:loading', true);
    },
    setNotLoading(){
      /**
       * Устанавливает значение loading на false
       */
      this.isLoading = false;
      this.$emit('update:loading', false);
    },
  },
  created() {
  }

}
